import React from 'react'
import {NewCourses} from '../components/ListNewCourses'
import {Courses} from '../components/ListCourses'
import {Typography} from '../components/Typography'
import {ChamadaAzul} from '../components/ChamadaAzul'
import {ImgFilters} from '../components/ImgFilters'
import {Depositions} from '../components/Depoimentos'
import coursesImage from '../img/courses-01.png'
import {useRecorrenceCoursesQuery} from '../utils/hooks/useRecorrenceCoursesQuery'

const Hero = () => {
  return (
    <div className="relative w-full h-40">
      <ImgFilters img={coursesImage} variant="purple" transparency />
    </div>
  )
}

const Breadcrumbs = () => {
  return (
    <div className="p-8 lg:px-32">
      <Typography as="a" uppercase>
        Plataforma
      </Typography>{' '}
      <Typography as="span">/ </Typography>
      <Typography as="a" uppercase>
        Cursos
      </Typography>
    </div>
  )
}

export const CoursesPageTemplate = ({blueCall = {}}) => {
  const courses = useRecorrenceCoursesQuery()
  return (
    <div>
      <Hero />
      <Breadcrumbs />
      <NewCourses courses={courses.slice(0, 3)} />
      <Courses courses={courses} />
      <ChamadaAzul
        text={blueCall.text}
        linkText={blueCall.button}
        link={blueCall.link}
      />
      <Depositions />
    </div>
  )
}

const Template = ({pageContext}) => {
  console.log({pageContext})
  return <CoursesPageTemplate {...pageContext?.frontmatter} />
}

export default Template
